import React from 'react';
import moment from 'moment';
import t from 'tcomb-form';

import DatePickInputWrapper from './utils/DatePickInputWrapper';


class DatePlaceholderInput extends t.form.Textbox {
    getTemplate() {
        return (locals) => {
            let classNames = ["form-group", 'form-group-depth-' + locals.path.length, "datepicker-wrapper"];
            const disabled = this.props.options.disabled;
            let dateInput = <input disabled={disabled} type="text" className={this.props.className} onChange={e => e.preventDefault()} placeholder={this.props.placeholder} value={locals.value} />;
            if (!disabled) {
                dateInput = (
                        <DatePickInputWrapper value={locals.value} disabled={disabled} maxDate={this.props.maxDate} minDate={this.props.minDate} onValueChange={locals.onChange} isRequired={this.props.isRequired} onChange={e => e.preventDefault()}>

                        </DatePickInputWrapper>
                );
            }
            return (
                <label className="form-control form-control-date">
                    <h3 className="label-title">Start date</h3>
                    <div className={classNames.join(' ')}>
                        {dateInput}
                        {locals.error ? <span className="help-block error-block">{locals.error}</span> : null}
                    </div>
                </label>
            );
        };
    }
}

DatePlaceholderInput.defaultProps = {
    id: 'date-picker',
    minDate: moment().format('YYYY-MM-DD'),
    placeholder: '',
    isRequired: true
};

DatePlaceholderInput.propTypes = {
    id: React.PropTypes.string,
    className: React.PropTypes.string,
    placeholder: React.PropTypes.string,
    maxDate: React.PropTypes.string, // YYYY-MM-DD
    minDate: React.PropTypes.string,
    isRequired: React.PropTypes.bool
};

export default DatePlaceholderInput;



/** WEBPACK FOOTER **
 ** ./app/src/components/Form_widgets/DatePlaceholderInput.jsx
 **/